import { AccountObjectDto } from "../account-object/account-object.dto";
import { DtoInclude, DtoIncludeNumber } from "../../../core/store/dto/dto";

export class CategoryDto extends AccountObjectDto {
    @DtoInclude
    title: string;
    @DtoIncludeNumber
    sequence: number;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.dto.ts